export { ResultsCount } from './ResultsCount';
